/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'

import Switch from "react-switch"

import { get, put } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  const [user, setUser] = useState('')
  const [userStatus, setUserStatus] = useState()

  const token = localStorage.getItem('token')

  document.title = 'کاربر'

  useEffect(() => {
    get(`/api/admin/users/${id}?token=${token}`)
      .then(respose => {
        setUser(respose.data.data[0])
        setUserStatus(respose.data.data[0].status)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })

  }, [id, token])

  const statusHandler = () => {
    let data = { status: true }
    setUserStatus(!userStatus)
    if (userStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/users/status/${id}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/users')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }
  
  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'user'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
                <Switch onChange={statusHandler} 
                  checked={userStatus ? userStatus : false} 
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                  />
              </div>
            </div>
          </div>
          <form className='form'>
            <div className='title'>
              * اطلاعات کاربر فقط جهت نمایش است. برای غیرفعال کردن کاربر جهت عدم دسترسی به اپلیکیشن از سوییچ بالا استفاده کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات کاربر
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>نام :</label>
                <input id='foodName' readOnly defaultValue={user ? user.name : ''} type='text' placeholder='مثلا علی' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>شماره موبایل :</label>
                <input id='foodPrice' readOnly defaultValue={user ? user.phoneNumber : ''} className='ltrdirection' type='text' placeholder='25...' />
                <small id='foodPriceAlert'>قیمت باید وارد شود</small>
              </div>
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodLevele'>آدرس ایمیل :</label>
                <input id='foodLeveleDetails' readOnly className='ltrdirection' defaultValue={user ? user.email : ''} type='text' />
                <small id='foodLeveleDetailsAlert'>اولویت باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodLevele'>میزان کیف پول :</label>
                <input id='foodLeveleDetails' readOnly className='ltrdirection' defaultValue={user ? user.valet : ''} type='text' />
                <small id='foodLeveleDetailsAlert'>اولویت باید وارد شود</small>
              </div>
            </div>
          </form>

          <form className='form'>
            <div className='title'>
              * افزایش کیف پول مشتری (دقت کنید جهت افزایش کیف پول نیاز به کد دو مرحله ای و رمز دارید)            
            </div>
            <div className='lineTitleFood'>
              <hr />
              افزایش کیف پول
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>مبلغ :</label>
                <input id='foodName' readOnly defaultValue='0' type='text' placeholder='مثلا پیتزا' />
                <small id='foodNameAlert'>مبلغ باید وارد شود</small>
              </div>
            </div>
            <button className='createButton'>افزایش موجودی</button>
          </form>

          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
